import AdoptionTrackerAPI from '../../services/AdoptionTrackerAPI'

/**
 * State for the Agency Dashboard + Metric x Location Report. Both are scoped
 * to "whichever agency the encrypted SSO blob resolves to" — same reasoning
 * as modules/location.js.
 */
export default {
  namespaced: true,

  state: () => ({
    loading: true,
    error: null,
    configured: null,
    companyId: null,
    agencyName: null,
    windowDays: 14,
    stats: { total_locations: 0, avg_score: 0, at_risk: 0 },
    distribution: { green: 0, yellow: 0, red: 0 },
    locations: [],
    metrics: {},
    timeline: [],
    metricTimeline: {},
    report: null, // { configured, locations: [{location_id, name, overall_score, metrics}] }
  }),

  mutations: {
    SET_LOADING(state, value) { state.loading = value },
    SET_ERROR(state, value) { state.error = value },

    SET_AGENCY_DATA(state, data) {
      state.configured = data.configured
      state.companyId = data.company_id ?? null
      state.agencyName = data.agency_name ?? null
      state.windowDays = data.window_days ?? state.windowDays
      state.stats = data.stats ?? state.stats
      state.distribution = data.distribution ?? state.distribution
      state.locations = data.locations ?? []
      state.metrics = data.metrics ?? {}
      state.timeline = data.timeline ?? []
      state.metricTimeline = data.metric_timeline ?? {}
    },

    SET_REPORT(state, data) { state.report = data },
  },

  actions: {
    async fetchAgencyData({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const data = await AdoptionTrackerAPI.getAgencyData()
        commit('SET_AGENCY_DATA', data)
        return data
      } catch (e) {
        commit('SET_ERROR', 'Failed to load agency data. Please reload the page.')
        throw e
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchReport({ commit }, { page = 1, search = '', perPage = 10 } = {}) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const data = await AdoptionTrackerAPI.getMetricLocationReport(page, search, perPage)
        commit('SET_REPORT', data)
        return data
      } catch (e) {
        commit('SET_ERROR', 'Failed to load report. Please reload the page.')
        throw e
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async changeWindow({ dispatch }, windowDays) {
      await AdoptionTrackerAPI.updateAgencyWindow(windowDays)
      // No backfill to poll for — the agency aggregation is computed live
      // (and cached briefly), so a plain refetch already reflects it.
      await dispatch('fetchAgencyData')
    },
  },
}
